<template>
  <div
    :data-qa-id="`passengersData.saved.pax.${paxIdx}.card`"
    role="button"
    tabindex="0"
    class="bg-background-neutral-secondary flex w-full cursor-pointer items-center justify-between rounded-2xl border p-4 text-left"
    :class="
      checked ? 'border-background-positive-primary' : 'border-transparent'
    "
    @click="$emit('onPassengerSelect', passenger)"
    @keydown.enter.prevent="$emit('onPassengerSelect', passenger)"
    @keydown.space.prevent="$emit('onPassengerSelect', passenger)"
  >
    <div class="min-w-0 flex-1">
      <div class="text-text-neutral-primary flex text-base font-semibold">
        <p class="initials">
          <template v-if="genderPrefix">{{ genderPrefix }} </template
          >{{ passenger.lastName }} {{ passenger.firstName }}
        </p>
      </div>
      <p class="text-text-neutral-quaternary text-sm">
        {{ paxDocumentText }}
      </p>
    </div>
    <button
      :data-qa-id="`passengersData.saved.pax.${paxIdx}.edit`"
      type="button"
      class="shrink-0 p-1"
      @click.stop="$emit('onPassengerEditClick', passenger)"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.423 1.5709C13.6238 1.57879 13.8132 1.66611 13.9496 1.81365L16.6922 4.78061C16.9762 5.08785 16.9574 5.56715 16.6502 5.85116L7.00751 14.7647C6.90867 14.856 6.78727 14.9194 6.6558 14.9483L2.75203 15.8058C2.48934 15.8635 2.21575 15.7776 2.03319 15.5801C1.85063 15.3826 1.78646 15.1031 1.8646 14.8458L3.02575 11.0213C3.06485 10.8925 3.13757 10.7765 3.23641 10.6851L12.879 1.77158C13.0266 1.6352 13.2223 1.56301 13.423 1.5709ZM13.3512 3.39844L4.41583 11.6582L3.69011 14.0485L6.12997 13.5125L15.0654 5.25279L13.3512 3.39844ZM1.66663 17.6745C1.66663 17.2561 2.0058 16.9169 2.4242 16.9169H17.5757C17.9941 16.9169 18.3333 17.2561 18.3333 17.6745C18.3333 18.0929 17.9941 18.432 17.5757 18.432H2.4242C2.0058 18.432 1.66663 18.0929 1.66663 17.6745Z"
          fill="#4EBC73"
        />
      </svg>
    </button>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { bookingPassengerEntity } from 'freedom-shared';
  import type { Passenger } from '@aviata/booking-data';

  type SavedPassenger = Passenger & {
    document: Passenger['document'] & { type?: string };
  };

  const GENDER_PREFIX: Record<string, string> = {
    M: 'Mr.',
    F: 'Mrs.',
  };

  const props = defineProps<{
    passenger: SavedPassenger;
    checked: boolean;
    paxIdx: number;
  }>();

  defineEmits<{
    onPassengerSelect: [passenger: Passenger];
    onPassengerEditClick: [passenger: Passenger];
  }>();

  const genderPrefix = computed(
    () => GENDER_PREFIX[props.passenger.gender] ?? '',
  );

  const paxDocumentText = computed(() =>
    bookingPassengerEntity.lib.getPaxDocText(
      props.passenger.document.type ?? '',
      props.passenger.document.number,
    ),
  );
</script>

<style scoped>
  .initials {
    overflow-wrap: anywhere;
  }
</style>
